module.exports = __webpack_public_path__ + "static/img/8.b8a5536.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/8.png
// module id = UcsF
// module chunks = 0